import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { business, navigation } from '../data/site';
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="sticky top-0 z-40 border-b border-line bg-cream/95 backdrop-blur" data-id="element-43" data-mp="2rlmb17io1wf8">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 md:px-8" data-id="element-44" data-mp="2wjxk3g1502we">
        <Link to="/" className="flex flex-col leading-none" aria-label="Vincent Monti, accueil" data-id="element-45" data-mp="31d9x0swgel9b">
          <span className="font-serif text-2xl font-medium text-forest" data-id="element-46" data-mp="36a0enknwpowu">{business.name}</span>
          <span className="mt-1 text-xs text-ink-muted" data-id="element-47" data-mp="3bb64naq6my2o">
            {business.activity} · {business.city}
          </span>
        </Link>

        <nav aria-label="Navigation principale" className="hidden lg:block" data-id="element-48" data-mp="3f9ngg7kjswqf">
          <ul className="flex items-center gap-8" data-id="element-49" data-mp="2wmfjorcmrg7u">
            {navigation.map(item => <li key={item.to} data-id="element-50" data-mp="2rkyggp6obho3">
                <NavLink to={item.to} end className={({
              isActive
            }) => `whitespace-nowrap text-sm font-medium transition-colors duration-150 ${isActive ? 'text-forest' : 'text-ink-muted hover:text-forest'}`} data-id="element-51" data-mp="2ro49ugmc55pm">
                  {item.label}
                </NavLink>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-3" data-id="element-52" data-mp="35jpw4g16pbec">
          <Link to="/#devis" className="hidden whitespace-nowrap rounded-full bg-forest px-5 py-2.5 text-sm font-medium text-cream transition-colors duration-150 hover:bg-forest-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-clay focus-visible:ring-offset-2 focus-visible:ring-offset-cream sm:inline-flex" data-id="element-53" data-mp="30mzgfttakhtg">
            Demander un devis
          </Link>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'} className="inline-flex h-10 w-10 items-center justify-center rounded-full text-forest hover:bg-cream-dark lg:hidden" data-id="element-54" data-mp="1wcxngsyn88xv">
            {open ? <XIcon className="h-5 w-5" data-id="element-55" data-mp="1cof7n1zj27vu" /> : <MenuIcon className="h-5 w-5" data-id="element-56" data-mp="1cpqbt2wvxhnh" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-57" data-mp="yppa5l8sq66y">
        {open && <motion.nav id="mobile-menu" aria-label="Navigation mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-line bg-cream lg:hidden" data-id="element-58" data-mp="yr0d5iuf39x0">
            <ul className="mx-auto max-w-7xl px-5 py-4" data-id="element-59" data-mp="mfg1wh7m1fcr">
              {navigation.map(item => <li key={item.to} data-id="element-60" data-mp="hgwcg6tt5lfn">
                  <NavLink to={item.to} end className={({
              isActive
            }) => `block py-3 font-serif text-xl ${isActive ? 'text-forest' : 'text-ink'}`} data-id="element-61" data-mp="hdqnqsp3clkg">
                    {item.label}
                  </NavLink>
                </li>)}
              <li className="pt-3" data-id="element-62" data-mp="105jiosnq0gut">
                <Link to="/#devis" onClick={() => setOpen(false)} className="inline-flex rounded-full bg-forest px-5 py-3 text-sm font-medium text-cream" data-id="element-63" data-mp="108fjcoqydjmy">
                  Demander un devis
                </Link>
              </li>
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}